<template>
  <teleport to="body">
    <transition>
      <nav class="menu-panel" v-if="menuStore.menuPanelVisible">
        <div v-if="authStore.isAuth">
          <p class="username"><i class="fa-solid fa-user"></i>{{ authStore.user?.staff_name }} さん</p>
          <div class="datetime" v-if="Config.APP_DEBUG">
            <i class="fa-solid fa-clock"></i>ｼｽﾃﾑ日時
            <datetime-picker v-model="configStore.sysDatetime" @update:modelValue="updateDatetime" :minutesIncrement="5" :clearable="false" ></datetime-picker>
          </div>
        </div>
        <ul>
          <li class="item">
            <div v-on:click="pressMenu(RouterConst.HOME)">
              <i class="fa-solid fa-house-user"></i>
              <p>ホーム<span v-if="APP_MODE.KINTAI === Config.APP_MODE"><br>（打刻）</span></p>
            </div>
          </li>

          <li class="item">
            <div v-on:click="pressMenu(RouterConst.SHINSEI_MENU)">
              <i class="fa-solid fa-inbox"></i>
              <p>申請の<br>管理</p>
            </div>
          </li>

          <li class="item" v-if="Config.APP_MODE === APP_MODE.KINTAI && authStore.hasPermission(PermissionConst.GET_DAKOKU)">
            <div v-on:click="pressMenu(RouterConst.KINMU_LIST)">
              <i class="fa-solid fa-table-list"></i>
              <p>タイム<br>シート</p>
            </div>
          </li>

          <li class="item">
            <div v-on:click="pressMenu(RouterConst.OSHIRASE_LIST)">
              <i class="fa-solid fa-bullhorn"></i>
              <p>お知らせ<br>一覧</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.PX) && (Config.APP_MODE == APP_MODE.JINJI)">
            <div v-on:click="pressMenu(RouterConst.PX_KINTAI_CSV)">
              <!-- <i class="fa-solid fa-file-export"></i> -->
              <i class="fas fa-prescription"></i>
              <p>PX<br>連携</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.KOYOUKEIYAKU) && (Config.APP_MODE == APP_MODE.JINJI)">
            <div v-on:click="pressMenu(RouterConst.KOYOUKEIYAKU_MENU)">
              <i class="fa-regular fa-file-lines"></i>
              <p>雇用<br>契約</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.YUUKYUU_KANRI) && (Config.APP_MODE == APP_MODE.JINJI)">
            <div v-on:click="pressMenu(RouterConst.YUUKYUU_KANRI_LIST)">
              <i class="fa-solid fa-mug-hot"></i>
              <p>有給<br>管理</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.SYUUGYOU_KISOKU_VIEW_ALL)">
            <div v-on:click="pressMenu(RouterConst.SYUUGYOU_KISOKU_LIST)">
              <i class="fa-solid fa-scale-balanced"></i>
              <p>就業<br>規則</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.SYAIN_MASTER) && (Config.APP_MODE == APP_MODE.JINJI)">
            <div v-on:click="pressMenu(RouterConst.SYAIN_LIST)">
              <i class="fa-solid fa-users"></i>
              <p>社員<br>マスタ</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.DB_MASTER) && (Config.APP_MODE == APP_MODE.JINJI)">
            <div v-on:click="pressMenu(RouterConst.MST_MENU)">
              <i class="fas fa-database"></i>
              <p>マスタ<br>管理</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.SYSTEM_ADMIN) && (Config.APP_MODE == APP_MODE.JINJI)">
            <div v-on:click="pressMenu(RouterConst.PERMISSION_ROLES_SETTING)">
              <i class="fas fa-cogs"></i>
              <p>管理<br>画面</p>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.RENRAKU_SEARCH_VIEW)">
            <div v-on:click="pressMenu(RouterConst.RENRAKU_MENU)">
              <i class="fas fa-comment-dots"></i>
              <p>会社<br>連絡</p>
            </div>
          </li>

          <li class="item"
            v-if="authStore.hasPermission(PermissionConst.DAKOKU_IKKATSU_SYOUNIN)
                || authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)
                || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)"
            >
            <div v-on:click="pressMenu(RouterConst.MY_TASK)">
              <i class="fas fa-pen-clip"></i>
              <span>マイ<br>タスク</span>
            </div>
          </li>

          <li class="item" v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
            <div v-on:click="pressMenu(RouterConst.FURIDE_CSV_DOWNLOAD)">
              <i class="fas fa-file-csv"></i>
              <span>振出残</span>
            </div>
          </li>

          <li class="item logout">
            <div v-on:click="logout()">
              <i class="fa-solid fa-right-from-bracket"></i>
              <span>ログ<br>アウト</span>
            </div>
          </li>
        </ul>
        <div class="close" v-on:click="menuStore.panelClose()"><i class="fa-solid fa-x"></i><span>閉じる</span></div>
      </nav>
    </transition>
  </teleport>
</template>

<script lang="ts">
import router from '@/routers';
import { defineComponent } from 'vue'
import Config from '@/const/Config'
import { useAuthStore } from '@/store/auth';
import { useConfigStore } from '@/store/config';
import { useMenuStore } from '@/store/menu'
import { RouterConst } from '@/const/Router';
import { PermissionConst } from '@/const/Permission';
import { APP_MODE } from '@/const/Constants';
import { ConfigApi } from '@/api/ConfigApi';
import { useMyTaskCommonStore } from '@/store/mytask-common';
import LogoutVue from '@/pages/auth/Logout.vue';

export default defineComponent({
  emits: ['close'],
  setup(props, context) {
    const authStore = useAuthStore()
    const configStore = useConfigStore()
    const menuStore = useMenuStore()
    const myTaskCommonStore = useMyTaskCommonStore()

    const pressMenu = async (name: string, params: {} = {}) => {
      menuStore.panelClose()
      context.emit('close')
      if(name === RouterConst.MY_TASK){
        // メニューパネルからアクセスした場合、保存されている対象ID（スクロールに使用）をクリア（24.3.7 大塚）
        // 実装時点ではメニューパネル以外からはアクセスすることはないのでここだけでOK
        // もし今後マイタスクに移動するルートが増えた場合はrouterでfromによって制御したほうが良い
        await myTaskCommonStore.setTargetId(null)
      }
      router.push({ name, params })
    }
    const updateDatetime = async (val: string) => {
      const api = new ConfigApi()
      await api.setSystemDatetime(val)
    }
    const logout = async () => {
      router.push({name: RouterConst.LOGOUT})
    }

    return {
      pressMenu,
      authStore,
      configStore,
      menuStore,
      Config,
      updateDatetime,
      logout,
      RouterConst,
      PermissionConst,
      APP_MODE
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/menu-panel.scss';
</style>

